import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAOmsY9-2IUT70hi9Ym3SUWYivypqCGnmQ",
  authDomain: "ai-trading-predictions.firebaseapp.com",
  projectId: "ai-trading-predictions",
  storageBucket: "ai-trading-predictions.firebasestorage.app",
  messagingSenderId: "886481120857",
  appId: "1:886481120857:web:b7cf631e9fb39531330b48",
  measurementId: "G-877991YDY0"
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
